export enum RejectionReason {
    MaxPinnedPostsLimitExceeded = 'MaxPinnedPostsLimitExceeded',
}

export interface DefaultReduxErrorPayload {
    reason: RejectionReason;
}
